import type { JobResponse } from '~/types/hlx/jobResponse';

/** The canonical conversation exists, but this newly composed message was not sent. */
export class ExistingInquiryError extends Error {
  readonly name = 'ExistingInquiryError';

  constructor(readonly jobResponse: JobResponse) {
    super(
      'This conversation already exists. Your new message was not sent; your draft is preserved.'
    );
  }
}
